class HeroRotator extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-rotator__slide'));
    if (this.slides.length <= 1) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.slides.slice(1).forEach((slide) => {
        slide.hidden = true;
      });
      return;
    }

    this.intervalMs = (parseInt(this.dataset.interval, 10) || 20) * 1000;
    this.currentIndex = 0;

    this.rotate = this.rotate.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);

    this.start();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  start() {
    this.stop();
    this.timer = window.setInterval(this.rotate, this.intervalMs);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  onVisibilityChange() {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  }

  rotate() {
    const previous = this.slides[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    const next = this.slides[this.currentIndex];

    previous.classList.remove('hero-rotator__slide--active');
    next.classList.add('hero-rotator__slide--active');
  }
}

customElements.define('hero-rotator', HeroRotator);
